import React from 'react';
import './App.css';
import CameroonMap from './components/CameroonMap';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>La Chasse aux Trésors - Orange Cameroun</h1>
      </header>
      <main>
        <CameroonMap />
      </main>
      <footer>
        <p> {new Date().getFullYear()} Orange Cameroun. Tous droits réservés.</p>
      </footer>
    </div>
  );
}

export default App;
